import { render, staticRenderFns } from "./team-tree-select.vue?vue&type=template&id=28340c38&scoped=true"
import script from "./team-tree-select.vue?vue&type=script&lang=js"
export * from "./team-tree-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28340c38",
  null
  
)

export default component.exports